import { useEffect, useState } from "react";

const LINKS = [
  { id: "#latest", label: "最新猛料" },
  { id: "#people", label: "人物时间线" },
  { id: "#comp", label: "事件合集" },
  { id: "#year", label: "按年总览" },
  { id: "#deep", label: "深扒档案" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200/70 bg-background-50/85 backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex w-full max-w-[1200px] items-center justify-between px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-fire-fill text-base leading-none"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            国产黑料
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {LINKS.map((link) => (
            <a
              key={link.id}
              href={link.id}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#deep"
            className="hidden whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 sm:inline-flex"
          >
            去翻档案
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 md:hidden"
          >
            <i className={`ri-${open ? "close-line" : "menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 px-4 pb-4 pt-2 backdrop-blur-md md:hidden">
          {LINKS.map((link) => (
            <a
              key={link.id}
              href={link.id}
              onClick={() => setOpen(false)}
              className="block whitespace-nowrap rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}